import React from 'react'

function Paper ({ className, fill }) {
  return (
    <svg fill={fill} className={className} viewBox='0 0 21.073 24'>
      <path d='M21.241,24H.168V0h14.29l6.783,6.783Zm-19.9-1.171H20.07V7.266l-6.1-6.1H1.339Zm0,0' />
      <path d='M252.524,17.692H245.5V10.668h1.171v5.854h5.854Zm0,0' transform='translate(-231.869 -10.083)' />
    </svg>
  )
}

Paper.defaultProps = {
  className: 'w-full h-full',
  fill: 'currentColor'
}

export default Paper
